import React from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AboutSection = () => {

    const { t, i18n } = useTranslation()

    
   
   
   const AboutList = [{
            "icon": "mdi mdi-lightbulb",
            "title": t('snap.label'),
            "content": t('snap_sub.label'),
        }, {
            "icon": "mdi mdi-projector-screen",
            "title": t('easy.label'),
            "content": t('easy_sub.label'),
        }, {
            "icon": "mdi mdi-nature",
            "title": t('order.label'),
            "content": t('order_sub.label'),
        },
        ]
    
    



        return (
            <React.Fragment>
                <section className="section bg-about bg-light-about bg-light" id="about">
                    <div className="container">
                        <Row>
                            <Col lg="4">
                                <div className="title-heading mb-5">
                                <h3 className="text-dark mb-1 font-weight-light text-uppercase">{t('about.label')}</h3>
                                    <div className="title-border-simple position-relative"></div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            {AboutList.map((about, index) => {
                                return <Col lg="4" key={index}>
                                            <div className="about-box about-light text-center p-3">
                                                <div className="about-icon mb-4">
                                                    <i className={about.icon}></i>
                                                </div>
                                                <h4 className="font-weight-light"><Link to="#" className="text-dark">{about.title}</Link></h4>
                                                <p className="text-muted f-14">{about.content}</p>
                                            </div>
                                        </Col>
                              })}
                         </Row>

                        <Row className="align-items-center mt-5">
                            <Col md="6">
                                <div className="about-desc">
                                    <h3 className="text-dark mb-3 font-weight-light">{t('about_caption.label')}</h3>
                                    <p className="text-muted f-15">{t('about_text.label')}</p>
                                   
                                </div>
                            </Col>

                            <Col md="6">
                                <div className="about-img  position-relative p-4">
                                    <img src="images/jrinv_iphone.png" alt="" className="w-50 img-fluid mx-auto d-block" />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </React.Fragment>
        );
    
}
export default AboutSection;